import * as React from 'react';
import type {View} from '@sail/engine';
import {createView, view} from '@sail/engine';
import {useEffect, useRef} from 'react';
import {css} from '../../css';
import {useScrollOverflow} from '../../hooks/useScrollOverflow';
import type {DrawerSize} from './BaseDrawer';

export const BottomSheetTabContent = createView(
  ({
    children,
    isSelected,
    isShowingTabList,
    setIsScrolled,
    setIsOverflowing,
    contentWrapperRef,
    size,
  }: View.IntrinsicElement<'div'> & {
    isSelected: boolean;
    isShowingTabList: boolean;
    setIsScrolled: (isScrolled: boolean) => void;
    setIsOverflowing: (isOverflowing: boolean) => void;
    contentWrapperRef: React.RefObject<HTMLDivElement>;
    size: DrawerSize;
  }) => {
    const scrollContentRef = useRef<HTMLDivElement>(null);
    const {isScrolled, isOverflowing, onScroll} = useScrollOverflow(
      contentWrapperRef,
      scrollContentRef,
    );

    useEffect(() => {
      if (isSelected) {
        setIsScrolled(isScrolled && !isShowingTabList);
        setIsOverflowing(isOverflowing);
      }
    }, [
      isScrolled,
      isOverflowing,
      isSelected,
      isShowingTabList,
      setIsScrolled,
      setIsOverflowing,
    ]);

    return (
      <view.div
        ref={scrollContentRef}
        onScroll={onScroll}
        css={[
          css({
            width: 'fill',
            stack: 'y',
            position: 'relative',
            overflow: 'auto',
            overscrollBehaviorY: 'contain',
          }),
          size === 'small' ? css({font: 'body.medium'}) : css({}),
        ]}
      >
        {children}
      </view.div>
    );
  },
);
